const ua = {
	header: {
		quote:
			'Книги — это корабли мысли, странствующие по волнам времени и бережно несущие свой драгоценный груз от поколения к поколению. ',
		author: 'Бэкон Ф.',
		title1: 'Допоможе вам',
		p1: 'Швидше сформулювати свою ціль і розпочати читати',
		p2: 'Пропорційно розподілити навантаження на кожний день',
		p3: 'Відстежувати особистий успіх',
		title2: 'Також ви зможете',
		p4: 'Формувати особисту думку незалежну від інших',
		p5: 'Підвищити свої професійні якості опираючись на нові знання',
		p6: 'Стати цікавим співрозмовником',
		logout: 'Вихід',
		notifyLogout: 'Сподіваюсь ще побачимось 😘',
		mobBtnLog: 'Увійти',
		mobBtnReg: 'Реєстрація',
	},
	register: {
		login: 'Увійти',
		register: 'Реєстрація',
		text: 'Вже з нами?',
	},
	libraryForm: {
		book: 'Назва книги',
		author: 'Автор книги',
		date: 'Рік випуску',
		pages: 'Кількість сторінок',
		btnAdd: 'Додати',
	},
	mobileLibraryItem: {
		author: 'Автор',
		year: 'Рік',
		pages: 'Стор.',
		rating: 'Рейтинг',
		btn: 'Резюме',
	},
	readingListHeaders: {
		title: 'Назва книги',
		author: 'Автор',
		year: 'Рік',
		pages: 'Стор.',
		rating: 'Рейтинг книги',
	},
	listHeaders: {
		title: 'Назва книги',
		author: 'Автор',
		year: 'Рік',
		pages: 'Стор.',
	},
	libraryListHeaders: {
		goingToRead: 'Маю намір прочитати',
		currentlyReading: 'Читаю',
		finishedReading: 'Прочитано',
	},
	libraryEmpty: {
		step1: 'Крок 1.',
		text1: 'Створіть особисту бібліотеку',
		text2: 'Додайте до неї книжки, які маєте намір прочитати.',
		step2: 'Крок 2.',
		text3: 'Сформуйте своє перше тренування',
		text4: 'Визначте ціль, оберіть період, розпочинайте тренування.',
		btn: 'Окей',
	},
	myGoals: {
		title: 'Моя мета прочитати',
		text1: 'Кількість книжок',
		text2: 'Кількість днів',
		text3: 'Залишилось книжок',
	},
	myTraining: {
		title: 'Моє тренування',
		option: 'Обрати книги з бібліотеки',
		btn: 'Додати',
		warningFields: 'Всі поля мають бути заповнені!',
		warningAdded: 'Ви вже додали цю книгу!',
		start: 'Початок',
		end: 'Кінець',
	},
	results: {
		title: 'Результати',
		label1: 'Дата',
		label2: 'Кількість сторінок',
		btn: 'Додати результат',
		stat: 'СТАТИСТИКА',
		notify1part:
			'Ви ввели більше сторінок, ніж залишилося. Непрочитаних сторінок -',
		notify2part: ' . Введіть правильні дані',
	},
	resumeModal: {
		title: 'Обрати рейтинг книги',
		resume: 'Резюме',
		btnBack: 'Назад',
		btnSave: 'Зберегти',
	},
	statistics: {
		startBtn: 'Почати тренування',
		statTitle: 'Кількість сторінок / день ',
		time: 'ЧАС',
		plan: 'ПЛАН',
		fact: 'ФАКТ',
	},
	notFound: {
		title: 'Ой, лишенько!',
		text: 'Щось пішло не так. Спробуй тицьнути на цю кнопку.',
		btnBack: 'Оновити',
	},
	timer: {
		title1: 'До закінчення року залишилось',
		title2: 'До досягнення мети залишилось',
		days: 'ДН',
		hours: 'ГОД',
		min: 'ХВ',
		sec: 'СЕК',
	},
	trainingBookList: {
		title: 'Назва книги',
		author: 'Автор',
		year: 'Рік',
		pages: 'Стор.',
	},
	team: {
		footerText: '"Books Reading" від',
		teamButton: 'Назад',
		git: 'Посилання на GitHub',
		pavlo: {
			position: 'Team Lead',
			name: 'Павло Вовжинський',
		},
		tanya: {
			position: 'Scrum Master',
			name: 'Тетяна Давиденко',
		},
		nikita: {
			position: 'Розробник',
			name: 'Нікіта Крутоголов',
		},
		renat: {
			position: 'Розробник',
			name: 'Ренат Велієв',
		},
		oleh: {
			position: 'Розробник',
			name: 'Олег Поляков',
		},
		maksym: {
			position: 'Розробник',
			name: 'Максим Шостак',
		},
		valeriya: {
			position: 'Розробник',
			name: 'Валерія Дручиніна',
		},
		anastasiia: {
			position: 'Розробник',
			name: 'Анастасія Свечнікова',
		},
	},
	modalFaster: {
		text: 'Mолодець! Та ти можеш швидше!)',
		btnNew: 'Нове тренування',
		btnBack: 'Назад',
	},
	modalDone: {
		text: 'Щиро вітаю! Ще одна книга прочитана .',
		btnDone: 'Завершити',
	},
};

export default ua;
